<template>
    <!--    <div id="index">-->
    <div id="content">
        <img class="bc1" src="../assets/bc.png">

        <div class="left">
            <div class="ball ball1"><span class="ball_title">防止视疲劳</span>用眼时间提醒<br/>防止过度用眼</div>
            <div class="ball ball2"><span class="ball_title">眼健康自测</span>眼睛功能状况<br/>好坏一测就知道</div>
            <div class="ball ball3"><span class="ball_title">降低蓝光伤害</span>一键式护眼<br/>智能防蓝光</div>
            <div class="ball ball4"><span class="ball_title">免费视觉训练</span>每天5分钟训练<br/>提高眼睛功能</div>
        </div>
        <div class="download_box">
            <div class="download_left">

            </div>
            <div class="download">
                <div class="download_title">健康用眼</div>
                <div class="download_title">从这里开始</div>
                <div style="display: flex;   justify-content:center;">
                    <div><img class="download_code" src="../assets/androidCode.png"><a
                            class="download_footer" href="https://guanglang.oss-cn-hangzhou.aliyuncs.com/hyts.apk">安卓版下载</a></div>
                    <div style="margin-left: 50px;"><img class="download_code" src="../assets/iOSCode.png"><a
                            class="download_footer" href="https://itunes.apple.com/cn/app/id1278552265">iOS下载</a></div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "download"
    }

</script>

<style scoped>
    page {
        max-width: 100vw;
    }

    #content {
        position: relative;
        top: 0;
    }


    .bc1 {
        width: 100%;
    }

    .left {
        left: 19vw;
        top: 20px;
        position: absolute;

    }

    .download_box {
        display: flex;
        position: absolute;
        top: 0;
        flex-wrap: wrap;
        align-items:center;
        height: 34vw;
    }

    .download_left {
        width: 70vw;
        height:  34vw;
    }

    .download_title {
        color: #fff;
        font-size: 32px;
        text-align: center;
    }

    .download_code {
        width: 120px;
        display: block;
        margin-top: 20px;
    }

    .download_footer {
        margin-top: 8px;
        width: 120px;
        text-align: center;
        color: #41d7d6;
        font-size: 16px;
        line-height: 30px;
        border-radius: 5px;
        display: inline-block;
        background-color: #fff;
        font-weight: 500;
        text-decoration: none;
    }
    .download_footer:visited{
        color: #41d7d6;
    }

    .ball {
        width: 7.5vw;
        height: 7.5vw;
        border-radius: 100%;
        background-color: #28e7d6;
        z-index: 10;
        position: absolute;
        box-shadow: 0.3vw -0.3vw 0px rgba(40, 231, 214, 0.4);
        /*font-size: 14px;*/
        font-size: 0.8vw;
        color: #fff;
        text-align: center;
        flex-direction: column;
        justify-content: center;
        display: flex;
        white-space: nowrap;
    }

    .ball_title {
        font-size: 1vw;
        margin-bottom: 3px;

    }

    .ball1 {
        left: 0;
        top: 22vw;
    }

    .ball2 {
        left: -1.5vw;
        top: 8vw;
    }

    .ball3 {
        top: 0vw;
        left: 12vw;
    }

    .ball4 {
        left: 28vw;
        top: 5vw;
    }

    @media (max-width: 1050px) {
        .left {
            width: 40vw;
            left: 19vw;
            top: 20px;
            z-index: 100;
            position: absolute;
            display: none;
        }

        .ball {
            font-size: 0.8vw;
            box-shadow:none;

        }

        .ball1 {
            left: -10vw;
            top: 200px;
            background-color: rgba(0, 0, 0, 0);
        }

        .ball2 {
            left: -15vw;
            top: 100px;
            background-color: rgba(0, 0, 0, 0);
        }

        .ball3 {
            top: 0px;
            left: 12vw;
            background-color: rgba(0, 0, 0, 0);
        }

        .ball4 {
            left: 40vw;
            top: 100px;
            background-color: rgba(0, 0, 0, 0);
        }

        .ball_title {
            font-size: 1vw;
            margin-bottom: 0px;

        }

        .download_left{
            height: 300px;

        }
        .bc1 {
            height: 350px;
        }

        .download {
            width: 100vw;
            color: #000000;
            margin-top: 50px;

        }

        .download_title {
            color: #41d7d6;
        }

        .download_footer {
            color: #fff;
            background-color: #41d7d6;

        }
        .download_footer:visited{
            color: #fff;
        }
    }
</style>